<template>
  <v-select class="language-dropdown" :icon="data[selectedIndex]?.icon ? langIcon(data[selectedIndex]?.icon) : ''">
    <v-option
      v-for="(lang, index) in data"
      :key="index"
      :graphic="lang.icon ? 'icon' : ''"
      :value="lang.title"
      :icon="lang.icon ? langIcon(lang?.icon) : ''"
      tabindex="-1"
      aria-disabled="false"
      role="option"
      :text="lang.title"
      @click="
        selectedIndex = index;
        emit('selected', selectedIndex);
      "
    />
    <slot name="optionalContent" />
  </v-select>
</template>
<script setup lang="ts">
import { PropType, ref } from 'vue';
import { CodeExampleOptions } from '@bifrost-dev-docs-mfe/common/types/examples';
import { VSelect, VOption } from '@vonage/vivid-vue';

defineProps({
  data: { type: Array as PropType<CodeExampleOptions>, required: true },
});

const emit = defineEmits(['selected']);

const selectedIndex = ref(0);
function langIcon(lang: string) {
  return lang === 'curl' || lang === 'ios' ? `${lang}-mono` : `${lang}-color`;
}
</script>
